import React from 'react';
import {
  Box,
  constants,
  Center,
  DefaultPageTemplate,
  Title,
} from '@thecb/components';
import AlertBar from '../../components/alert-bar';
import { CashDropForm } from './CashDropForm';

const Header = ({ alertBar, alertBarActions }) => (
  <Box width="100%" padding="16px 0">
    <Center maxWidth="55.429rem">
      {alertBar.alerts.length > 0 && (
        <Box padding="16px 0">
          <AlertBar {...alertBar} {...alertBarActions} />
        </Box>
      )}
      <Title
        color={constants.colors.CHARADE_GREY}
        weight={constants.fontWeights.FONT_WEIGHT_BOLD}
      >
        Cash Drop
      </Title>
    </Center>
  </Box>
);

const CashDrop = ({
  alertBars,
  actions,
  forms,
  submitCashDropForm,
  terminalSession,
}) => {
  const content = (
    <Box padding="0 0 2rem">
      <CashDropForm
        forms={forms}
        {...actions.forms.cashDropForm}
        {...forms.cashDropForm}
        submitCashDropForm={submitCashDropForm}
        terminalSession={terminalSession}
      />
    </Box>
  );

  return (
    <DefaultPageTemplate
      maxWidth="55.429rem"
      header={
        <Header
          key="CashDropHeader"
          alertBar={alertBars.cashDropAlertBars}
          alertBarActions={actions.alertBars.cashDropAlertBars}
        />
      }
      content={content}
      gutters="0"
    />
  );
};

export default CashDrop;
